import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledTeamsSettingsCardHeader = styled(Box)`
  display: flex;
  position: relative;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.property('palette.divider')};
  padding: ${props => props.theme.spacing(2)};
  gap: ${props => props.theme.spacing(1)};
  
  .TeamsSettingsCardHeader {
    &-info {
      width: 1px;
      flex-grow: 1;
      overflow: hidden;
      max-width: calc((100% - ${props => props.theme.layout('10sp')}) / 2);

      &-title {
        .FieldInline {
          flex-grow: 1;
          overflow: hidden;
          
          .FieldInline-field {
            display: flex;
            flex-direction: column;
          }

          .FormField-name-name {
            .Typography {
              ${props => props.theme.font2Css('h6')}
            }
          }
          .FormControl-readOnly {
            &.FormField-name-isPrivate, &.FormField-name-isExternal {
              display: none;
            }
          }
        }
      }

      &-active {
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
        height: calc(100% - ${props => props.theme.spacing(4)});
        left: 0;

        position: absolute;
        display: flex;
        justify-content: center;
        pointer-events: none;

        > .FieldInline {
          min-width: ${props => props.theme.layout('10sp')};
          margin-left: ${props => props.theme.layout('5sp')};
          margin-top: ${props => props.theme.layout(5)};
          pointer-events: all;

          .FieldInline-field {
            flex-direction: column !important;
          }
          
          .ListField {
            &-label {
              ${props => props.theme.font2Css('body2')};
              display: block !important;
              margin: 0 !important;
            }
            &-readOnly {
              > * {
                width: fit-content;
              }
            }
          }
        }
      }
      
      &-subtitle {
        display: flex;
        align-items: center;
        gap: ${props => props.theme.spacing(1)};
      }
    }
    
    &-buttons {
      display: flex;
      align-self: flex-start;
      align-items: flex-start;
      gap: ${props => props.theme.spacing(1)};
      
      .Button {
        white-space: nowrap;
      }
    }
  }

  ${props => props.theme.breakpoints.down('sm')} {
    .TeamsSettingsCardHeader {
      &-info {
        max-width: unset;
      }
    }
  }
  ${ComponentStyles}
`;

StyledTeamsSettingsCardHeader.propTypes = {
  theme: PropTypes.object
};

export default StyledTeamsSettingsCardHeader;
